import OutlineOne from '@assets/icons/outline-one.svg'
import { Icon } from './Icon'

export const OutlineOneIcon = Icon(OutlineOne)
